import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Star1 } from 'iconsax-react';
import { styled } from '@mui/material/styles';

const StyledRatingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '2px',
}));

StarRating.propTypes = {
  value: PropTypes.number.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
};

StarRating.defaultProps = {
  size: 20,
  color: '#2574EB',
};

export default function StarRating({ value, size, color }) {
  return (
    <StyledRatingContainer>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star1
          key={star}
          size={size}
          color={color}
          variant={star <= value ? 'Bold' : 'Outline'}
        />
      ))}
    </StyledRatingContainer>
  );
}
